
import Vue from "vue";
import { Action } from "vuex-class";
import firebase from "firebase";
import { ActionMethod } from "vuex";
import { Component, Prop } from "vue-property-decorator";

import Chat from "@/components/core/Chat.vue";
import AccessibilitySkipLink from "@/components/common/AccessibilitySkipLink.vue";

@Component({
  name: "Footer",
  components: {
    Chat,
    AccessibilitySkipLink,
  },
})
export default class Footer extends Vue {
  @Action getTokenChat!: ActionMethod;

  @Prop({ default: "" }) readonly uriChat!: string;

  get detectMob() {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i,
    ];

    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
  }

  off = typeof process.env.VUE_APP_API_CHAT_TOKEN === "string";

  consFrame = process.env.VUE_APP_API_CHAT_FRAME;

  whatsappUrl = process.env.VUE_APP_API_WHATSAPP;

  isWhatsAppEnabled = false;

  isChatEnabled = false;

  async created() {
    const firebaseConfig = {
      apiKey: "AIzaSyDR7yGghTFp-16FQX0I4xILNP_FbB6IpDA",
      authDomain: "claroflex-prod.firebaseapp.com",
      databaseURL: "https://claroflex-prod.firebaseio.com",
      projectId: "claroflex-prod",
      storageBucket: "claroflex-prod.appspot.com",
      messagingSenderId: "244910085520",
      appId: "1:244910085520:web:ce4708a57168e878ba4f15",
      measurementId: "G-XCN7NYN1GL",
    };

    if (!firebase.apps.length) {
      firebase.initializeApp(firebaseConfig);
      firebase.analytics();
    }

    const remoteConfig = firebase.remoteConfig();

    remoteConfig.settings.minimumFetchIntervalMillis = 10000;

    await remoteConfig.fetchAndActivate();

    this.isWhatsAppEnabled = remoteConfig.getBoolean("QA_show_whatsapp");

    this.isChatEnabled =
      remoteConfig.getBoolean("QA_show_chat") &&
      this.$router.currentRoute.name !== "NcndLink";
  }
}
